import { validateEnumTranslations } from '../../safety_checks';
import {
  CrmCampaignExclusionReason,
  CrmCommsTraceKind,
  CrmSequenceAnchor,
  CrmSequenceStepTiming,
} from '../crm-campaign';
import { CampaignErrorStatus, ProCampaignStatus, ProCampaignType } from '../namespace';

export const TRANSLATE_KEY_CRM_CAMPAIGN_EXCLUSION_REASON = 'CRM_CAMPAIGN_EXCLUSION_REASON_';
export const TRANSLATE_KEY_CRM_SEQUENCE_ANCHOR = 'CRM_SEQUENCE_ANCHOR_';
export const TRANSLATE_KEY_CRM_SEQUENCE_STEP_TIMING = 'CRM_SEQUENCE_STEP_TIMING_';
export const TRANSLATE_KEY_CRM_COMMS_TRACE_KIND = 'CRM_COMMS_TRACE_KIND_';
export const TRANSLATE_KEY_CRM_CAMPAIGN_STATUS = 'CRM_CAMPAIGN_STATUS_';
export const TRANSLATE_KEY_CRM_CAMPAIGN_TYPE = 'CRM_CAMPAIGN_TYPE_';
export const TRANSLATE_KEY_CRM_CAMPAIGN_ERROR = 'CRM_CAMPAIGN_ERROR_';

export const CrmCampaignStatusTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_CAMPAIGN_STATUS}${ProCampaignStatus.DRAFT}`]: 'Brouillon',
    [`${TRANSLATE_KEY_CRM_CAMPAIGN_STATUS}${ProCampaignStatus.SCHEDULED}`]: 'Programmée',
    [`${TRANSLATE_KEY_CRM_CAMPAIGN_STATUS}${ProCampaignStatus.SENDING}`]: 'Envoi en cours',
    [`${TRANSLATE_KEY_CRM_CAMPAIGN_STATUS}${ProCampaignStatus.TREAT_SENDING}`]: 'Envoi en cours',
    [`${TRANSLATE_KEY_CRM_CAMPAIGN_STATUS}${ProCampaignStatus.SENT}`]: 'Envoyée',
  },
};

export const CrmCampaignTypeTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_CAMPAIGN_TYPE}${ProCampaignType.EMAIL}`]: 'Email',
    [`${TRANSLATE_KEY_CRM_CAMPAIGN_TYPE}${ProCampaignType.SMS}`]: 'SMS',
  },
};

export const CrmCampaignErrorTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_CAMPAIGN_ERROR}${CampaignErrorStatus.NO_RECIPIENT_TO_SEND}`]:
      'Aucun destinataire au moment de l’envoi',
    [`${TRANSLATE_KEY_CRM_CAMPAIGN_ERROR}${CampaignErrorStatus.INSUFFICIENT_SMS_QUOTA}`]: 'Quota SMS insuffisant',
    [`${TRANSLATE_KEY_CRM_CAMPAIGN_ERROR}${CampaignErrorStatus.INSUFFICIENT_EMAIL_QUOTA}`]: 'Quota email insuffisant',
    [`${TRANSLATE_KEY_CRM_CAMPAIGN_ERROR}${CampaignErrorStatus.SENDING_BLOCKED_DURING_TRIAL}`]: 'Envoi bloqué',
    [`${TRANSLATE_KEY_CRM_CAMPAIGN_ERROR}${CampaignErrorStatus.PROVIDER_SEND_FAILED}`]:
      'Le fournisseur a refusé l’envoi',
    [`${TRANSLATE_KEY_CRM_CAMPAIGN_ERROR}${CampaignErrorStatus.CAMPAIGN_PROMO_BINDING_MISMATCH}`]:
      'Code promo joint inutilisable',
  },
};

export const CrmCampaignExclusionReasonTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_CAMPAIGN_EXCLUSION_REASON}${CrmCampaignExclusionReason.NO_ADDRESS}`]: 'Sans adresse',
    [`${TRANSLATE_KEY_CRM_CAMPAIGN_EXCLUSION_REASON}${CrmCampaignExclusionReason.NOT_ON_LIST}`]: 'Hors de la liste',
    [`${TRANSLATE_KEY_CRM_CAMPAIGN_EXCLUSION_REASON}${CrmCampaignExclusionReason.REFUSED}`]: 'A refusé',
    [`${TRANSLATE_KEY_CRM_CAMPAIGN_EXCLUSION_REASON}${CrmCampaignExclusionReason.IN_TRIAL}`]: 'En cours d’essai',
    [`${TRANSLATE_KEY_CRM_CAMPAIGN_EXCLUSION_REASON}${CrmCampaignExclusionReason.CALLBACK_TODAY}`]:
      'Rappel téléphonique prévu ce jour',
    [`${TRANSLATE_KEY_CRM_CAMPAIGN_EXCLUSION_REASON}${CrmCampaignExclusionReason.DUPLICATE}`]: 'Adresse en double',
  },
};

export const CrmSequenceAnchorTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_SEQUENCE_ANCHOR}${CrmSequenceAnchor.SIGNUP}`]: 'L’inscription',
    [`${TRANSLATE_KEY_CRM_SEQUENCE_ANCHOR}${CrmSequenceAnchor.TRIAL_ENDED}`]: 'La fin de l’essai',
    [`${TRANSLATE_KEY_CRM_SEQUENCE_ANCHOR}${CrmSequenceAnchor.AUDIENCE_ENTRY}`]: 'L’entrée dans l’audience',
  },
};

export const CrmSequenceStepTimingTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_SEQUENCE_STEP_TIMING}${CrmSequenceStepTiming.AFTER_PREVIOUS}`]:
      'X jours après l’étape précédente',
    [`${TRANSLATE_KEY_CRM_SEQUENCE_STEP_TIMING}${CrmSequenceStepTiming.WEEKDAY}`]:
      'Jour fixe, après l’étape précédente',
  },
};

export const CrmCommsTraceKindTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_COMMS_TRACE_KIND}${CrmCommsTraceKind.CAMPAIGN}`]: 'Campagne',
    [`${TRANSLATE_KEY_CRM_COMMS_TRACE_KIND}${CrmCommsTraceKind.SEQUENCE}`]: 'Séquence',
    [`${TRANSLATE_KEY_CRM_COMMS_TRACE_KIND}${CrmCommsTraceKind.SESSION_FOLLOWUP}`]: 'Email de suite de séance',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(
  CrmCampaignExclusionReason,
  CrmCampaignExclusionReasonTranslation,
  TRANSLATE_KEY_CRM_CAMPAIGN_EXCLUSION_REASON,
  true,
);
validateEnumTranslations(CrmSequenceAnchor, CrmSequenceAnchorTranslation, TRANSLATE_KEY_CRM_SEQUENCE_ANCHOR, true);
validateEnumTranslations(
  CrmSequenceStepTiming,
  CrmSequenceStepTimingTranslation,
  TRANSLATE_KEY_CRM_SEQUENCE_STEP_TIMING,
  true,
);
validateEnumTranslations(CrmCommsTraceKind, CrmCommsTraceKindTranslation, TRANSLATE_KEY_CRM_COMMS_TRACE_KIND, true);
validateEnumTranslations(ProCampaignStatus, CrmCampaignStatusTranslation, TRANSLATE_KEY_CRM_CAMPAIGN_STATUS, true);
validateEnumTranslations(ProCampaignType, CrmCampaignTypeTranslation, TRANSLATE_KEY_CRM_CAMPAIGN_TYPE, true);
validateEnumTranslations(CampaignErrorStatus, CrmCampaignErrorTranslation, TRANSLATE_KEY_CRM_CAMPAIGN_ERROR, true);
